(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/fractiongames/assets/javascript/react/index.js') >= 0) return;  svs.modules.push('/modules/fractiongames/assets/javascript/react/index.js');
"use strict";


const Router = svs.fractiongames.Router;
const target = document.getElementById('react-container');
const FractionGamesProvider = svs.numbergames.fractiongames.redux.FractionGamesProvider;
const App = () => React.createElement(React.StrictMode, null, React.createElement(FractionGamesProvider, null, React.createElement(Router, null)));
target && ReactDOM.render(React.createElement(App, null), target);

 })(window);